import { useContext } from "react"
import { GlobalsContext } from "../context/GlobalsContext"

export const useGlobals = () => useContext(GlobalsContext)
